const modalForm = () => {
    const registerDatepickerDialogFilter = () => {
        if (
            !window.gform ||
            typeof window.gform.addFilter !== 'function' ||
            window.__westgateDatepickerDialogFilterRegistered
        ) {
            return;
        }

        window.gform.addFilter('gform_datepicker_options_pre_init', (options, formId, fieldId) => {
            const originalBeforeShow = options.beforeShow;

            options.beforeShow = function (input, inst) {
                if (typeof originalBeforeShow === 'function') {
                    originalBeforeShow.call(this, input, inst);
                }

                const dialog = input?.closest('dialog.fifty-fifty-modal');
                const datepickerElement = inst?.dpDiv?.[0];

                if (dialog && datepickerElement) {
                    dialog.appendChild(datepickerElement);
                }
            };

            return options;
        });

        window.__westgateDatepickerDialogFilterRegistered = true;
    };

    const init = () => {
        const openButtons = document.querySelectorAll('[data-modal-target]');
        if (!openButtons.length) return;

        registerDatepickerDialogFilter();

        const closeModal = (modal) => {
            if (!modal || typeof modal.close !== 'function') return;
            if (modal.open) {
                modal.close();
            }
        };

        const openModal = (modal) => {
            if (!modal || typeof modal.showModal !== 'function') return;
            if (!modal.open) {
                modal.showModal();
            }

            const formId = modal.getAttribute('data-modal-form-id');
            if (formId && window.gform && typeof window.gform.doAction === 'function') {
                window.gform.doAction('gform_post_render', parseInt(formId, 10), 1);
            }
        };

        document.addEventListener('click', (event) => {
            const openTrigger = event.target.closest('[data-modal-target]');
            if (openTrigger) {
                const targetId = openTrigger.getAttribute('data-modal-target');
                const modal = targetId ? document.getElementById(targetId) : null;
                openModal(modal);
                return;
            }

            const closeTrigger = event.target.closest('[data-modal-close]');
            if (closeTrigger) {
                const modal = closeTrigger.closest('dialog.fifty-fifty-modal');
                closeModal(modal);
            }
        });

        document.addEventListener('click', (event) => {
            const dialog = event.target.closest('dialog.fifty-fifty-modal');
            if (dialog && event.target === dialog) {
                closeModal(dialog);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            const openModals = document.querySelectorAll('dialog.fifty-fifty-modal[open]');
            openModals.forEach((modal) => closeModal(modal));
        });
    };

    return {
        init
    };
};

export default modalForm;
